export default "__VITE_ASSET__uxUhDgfF__"